import React, { useState, useEffect } from 'react';
import { ref, onValue } from "firebase/database";
import { database } from './firebase';
import './App.css';

// Import badge images
import badge1 from './assets/Badge_1.png';
import badge2 from './assets/Badge_2.png';
import badge3 from './assets/Badge_3.png';
import badge4 from './assets/Badge_4.png';
import badge5 from './assets/Badge_5.png';

function AchievementPage() {
  const [achievements, setAchievements] = useState([]);
  const [badge, setBadge] = useState('');

  useEffect(() => {
    const achievementsRef = ref(database, 'transcriptions');
    onValue(achievementsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const achievementsArray = Object.entries(data).map(([key, value]) => ({
          id: key,
          ...value
        }));
        // Reverse the array to display the newest entries first
        setAchievements(achievementsArray.reverse());

        // Calculate the number of questions asked
        const numQuestions = achievementsArray.length;

        // Determine the badge based on the number of questions asked
        if (numQuestions >= 10 && numQuestions < 20) {
          setBadge('Bronze Badge');
        } else if (numQuestions >= 20 && numQuestions < 30) {
          setBadge('Silver Badge');
        } else if (numQuestions >= 30) {
          setBadge('Gold Badge');
        } else {
          setBadge('');
        }
      }
    });
  }, []);

  return (
    <div className="achievement-page">
      <h1>Achievements</h1>
      <div className="achievement-container">
        <div className="achievement-list">
          <ul>
            {achievements.map((achievement) => (
              <li key={achievement.id}>
                <p><strong>Questions:</strong> {achievement.transcription}</p>
                <p><strong>Response:</strong> {achievement.response}</p>
              </li>
            ))}
          </ul>
        </div>
        <div className="badge-system">
          <h2>Badges</h2>
          {badge && <p>Congratulations! You've earned the <strong>{badge}</strong></p>}
          {!badge && <p>Ask more questions to earn badges!</p>}
          <div className="badge-list">
            
            <div className="badge-item">
              <img src={badge2} alt="Badge 2" className="badge-image" />
              <p>REWARD For very creative Question!!!</p>
            </div>
            <div className="badge-item">
              <img src={badge4} alt="Badge 4" className="badge-image" />
              <p>5 Day Streak 🔥🔥🔥</p>
            </div>
            <div className="badge-item">
              <img src={badge3} alt="Badge 3" className="badge-image" />
              <p>REWARD For asking 20 questions</p>
            </div>

            <div className="badge-item">
              <img src={badge5} alt="Badge 5" className="badge-image" />
              <p>Keep going ON!!!!! ✨</p>
            </div>
            <div className="badge-item">
              <img src={badge1} alt="Badge 1" className="badge-image" />
              <p>REWARD For completing 10 questions in a Day!!</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AchievementPage;